module.exports = __webpack_public_path__ + "img/Roboto-Light.dd0bea1.svg";